import { render, staticRenderFns } from "./ModalDeleteFormItem.vue?vue&type=template&id=230dab14&scoped=true"
import script from "./ModalDeleteFormItem.vue?vue&type=script&lang=js"
export * from "./ModalDeleteFormItem.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "230dab14",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/opt/render/project/src/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('230dab14')) {
      api.createRecord('230dab14', component.options)
    } else {
      api.reload('230dab14', component.options)
    }
    module.hot.accept("./ModalDeleteFormItem.vue?vue&type=template&id=230dab14&scoped=true", function () {
      api.rerender('230dab14', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/components/modals/forms/ModalDeleteFormItem.vue"
export default component.exports